import React from 'react';
import Collapse from 'react-bootstrap/lib/Collapse';
import Dropdown from 'react-bootstrap/lib/Dropdown';
import { LocationPicker } from 'components/forms';
import LocationsField from 'components/events/LocationsField';

export default class extends React.Component {
    static propTypes = {
        name: React.PropTypes.string.isRequired,
        open: React.PropTypes.bool.isRequired,
        regions: React.PropTypes.array.isRequired,
        onChange: React.PropTypes.func.isRequired,
    };

    onChange = ({ value }) => {
        this.props.onChange(this.props.name, value);
    };

    handleLocationChanged = (regions) => {
        this.props.onChange(regions);
    };

    render() {
        return (
            <div className="search-filter">
                <div className="search-filter__header">
                    <span className="search-filter__title">Location</span>
                </div>

                <Collapse in={this.props.open}>
                    <div className="search-filter__filter">
                        <Dropdown id="locations" rootCloseEvent="click">
                            <Dropdown.Toggle noCaret={true}>
                                <LocationsField
                                    regions={this.props.regions}
                                />

                                <span className="arrow">
                                    <b role="presentation" />
                                </span>
                            </Dropdown.Toggle>

                            <LocationPicker
                                bsRole="menu"
                                onChange={this.handleLocationChanged}
                                regions={this.props.regions}
                            />
                        </Dropdown>
                    </div>
                </Collapse>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/VenueSearch/CityFilter.jsx